export const styles = {
  global: {
    ":root": {
      fontSize: "62.5%"
    },
    body: {
      p: "0px",
      m: "0px",
      bg: "surface",
      fontFamily: "sans",
      userSelect: "none",
      textRendering: "optimizeLegibility",
      WebkitFontSmoothing: "antialiased",
      MozOsxFontSmoothing: "grayscale"
    },
    "::-webkit-scrollbar-track": {
      display: "none"
    },
    "::-webkit-scrollbar": {
      width: "4px"
    },
    "::-webkit-scrollbar-thumb": {
      minHeight: "64px",
      borderRadius: "3px",
      bg: "scrollThumb"
    },

    "*": {
      boxSizing: "border-box",
      outline: "none"
    },

    "input::-webkit-inner-spin-button, input::-webkit-outer-spin-button": {
      WebkitAppearance: "none",
      MozAppearance: "none",
      appearance: "none",
      m: 0
    },

    ".ReactModal__Overlay": {
      opacity: 0,
      transition: "opacity 300ms ease-in-out"
    },

    ".ReactModal__Overlay--after-open": {
      opacity: 1
    },

    ".ReactModal__Overlay--before-close": {
      opacity: 0
    }
  }
};
